module.exports = __webpack_public_path__ + "img/receipt-check.69753db5.svg";